export const getNumberFromString = (value) => {
    const trimmedValue = value.trim();
    const transformedValueToNumber = Number(trimmedValue);
    return transformedValueToNumber;
};
